import * as WorkflowNodeService from '@/utils/workflow-node-service';

export default {
	props: {
		blockData: { type: Object },
		appData: { type: Object },
		originalAppData: { type: Object },
		actionData: { type: Object },
	},
	computed: {
		isConsolidateDataNode() {
			return WorkflowNodeService.isConsolidateDataNodeAndAction(this.blockData, this.actionData);
		},
		isLoop() {
			return WorkflowNodeService.isLoop(this.blockData);
		},
		isBranches() {
			return WorkflowNodeService.isBranches(this.blockData);
		},
	},
};
